import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="footer-main">
      <div className="footer-pattern-top" />
      
      <div className="footer-content">
        <div className="container-footer">
          <div className="footer-grid">
            {/* Logo & Description */}
            <div className="footer-section">
              <div className="footer-logo">
                <div className="logo-text">Meya</div>
                <div className="logo-subtitle">Beauté & Tradition</div>
              </div>
              <p className="footer-description">
                Un havre de paix où tradition orientale et bien-être moderne se rencontrent 
                pour vous offrir une expérience de relaxation authentique.
              </p>
            </div>

            {/* Navigation rapide */}
            <div className="footer-section">
              <h3 className="footer-title">Navigation</h3>
              <ul className="footer-links">
                <li><Link to="/revitalisation">Gamme Revitalisation</Link></li>
                <li><Link to="/pieds-mains">Beauté Pieds & Mains</Link></li>
                <li><Link to="/mere-fille">Offre Mère & Fille</Link></li>
                <li><Link to="/femme-enceinte">Femme Enceinte</Link></li>
                <li><Link to="/detente">Gamme Détente</Link></li>
                <li><Link to="/beaute-regard">Beauté du Regard</Link></li>
                <li><Link to="/anniversaire">Anniversaire</Link></li>
              </ul>
            </div>

            {/* Nos gammes */}
            <div className="footer-section">
              <h3 className="footer-title">Nos Services</h3>
              <ul className="footer-links">
                <li>Massages Traditionnels</li>
                <li>Soins Esthétiques</li>
                <li>Soins pour Femmes Enceintes</li>
                <li>Moments Mère & Fille</li>
                <li>Spa Anniversaire</li>
                <li>Beauté des Yeux</li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h3 className="footer-title">Contact</h3>
              <ul className="footer-contact">
                <li>
                  <MapPin className="icon-small" />
                  <span>
                    {contactInfo.address}<br />
                    {contactInfo.postalCode} {contactInfo.city}
                  </span>
                </li>
                <li>
                  <Phone className="icon-small" />
                  <a href={`tel:${contactInfo.phoneRaw}`}>{contactInfo.phone}</a>
                </li>
                <li>
                  <Mail className="icon-small" />
                  <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                </li>
              </ul>

              <div className="footer-social">
                <a href={contactInfo.socialMedia.instagram} className="social-icon" aria-label="Instagram">
                  <Instagram size={20} />
                </a>
                <a href={contactInfo.socialMedia.facebook} className="social-icon" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container-footer">
          <p>&copy; {new Date().getFullYear()} Meya Beauté & Tradition. Tous droits réservés.</p>
        </div>
      </div>

      <div className="footer-pattern-bottom" />
    </footer>
  );
};

export default Footer;
